export const BETA_FEATURE_TRACKING_NOTIFICATIONS = 'tracking_notifications'
